export default {
  en: {
    'bundles-reduced-rates.components.sku-list.title': 'ASIN',
    'bundles-reduced-rates.components.sku-list.save': 'Save',
    'bundles-reduced-rates.components.sku-list.duplicate-asin':
      'Cannot have duplicate ASIN numbers',
    'bundles-reduced-rates.components.sku-list.add-row': 'Add a row',
  },
};
